import React, { useEffect, useState, useRef } from "react";
import "../../../assets/scss/home.scss";
import "../../../assets/scss/tests.scss";
import "flatpickr/dist/flatpickr.css";
import "bootstrap/dist/css/bootstrap.css";
import "bootstrap-daterangepicker/daterangepicker.css";
import { useSelector } from "react-redux";
import Spinner from "../../../@core/components/spinner/Fallback-spinner";
import PagePagination from "../../../components/tables/pagination";
import Repository from "../../../configs/axios/repository";
import StudentsTable from "../../../components/tables/studentsTable";
import { useLocation, useHistory } from "react-router-dom";
import Modal from "react-modal";
import x_mark from "../../../assets/images/courses/group.svg";
import { Formik, Form, Field, ErrorMessage } from "formik";
import { Row, Col } from "reactstrap";
import Swal from "sweetalert2";
import { WithContext as ReactTags } from "react-tag-input";
import copy from "../../../assets/images/account/copy-regular.svg";
import validator from "validator";

const customStyles = {
    content: {
        top: "50%",
        left: "58%",
        right: "auto",
        bottom: "auto",
        transform: "translate(-50%, -50%)",
        background: "#F9FAFC 0% 0% no-repeat padding-box",
        padding: "20px 30px",
        width: "45%",
        zIndex: "9000",
        maxHeight: "600px",
    },
};

const CourseStudents = (props) => {
    const copyLinkRef = useRef(null);
    const locationState = useLocation();
    const isInvateValue = useSelector((state) => state.layout.isInvate);
    const [modalIsOpenForAddStudent, setIsOpenForAddStudent] =
        React.useState(false);
    const [alertVisible, setAlertVisible] = useState(false);
    const [modalIsOpenForLink, setIsOpenForLink] = React.useState(false);
    const role = useSelector((state) => state.layout.role);
    let canDoIt = false;
    const [loadingStudents, setLoadingStudents] = useState(false);
    const [loadingData, setLoadingData] = useState(false);
    const queryParameters = new URLSearchParams(window.location.search);
    const course_id = queryParameters.get("course_id");
    const [studentsData, setStudentsData] = useState([]);
    const [studentsEmails, setStudentsEmails] = useState([]);
    const [showData, setShowData] = useState(10);
    const [skipData, setSkipData] = useState(0);
    let courseName = locationState.state?.courseName;
    localStorage.setItem("isCreate", false);
    const [showCources, setShowCources] = useState(true);
    // const [validEmail, setValidEmail] = useState(false);

    const [tags, setTags] = useState([]);
    const [validEmail, setValidEmail] = useState("");
    const [newEmail, setNewEmail] = useState("");

    const handleAddition = (tag) => {
        if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(tag.text)) {
            setValidEmail("Invalid email format");
        } else {
            setTags([...tags, tag]);
            setValidEmail("");
        }
    };
    const handleCopyLink = () => {
        const range = document.createRange();
        const selection = window.getSelection();

        range.selectNode(copyLinkRef.current);
        selection.removeAllRanges();
        selection.addRange(range);

        document.execCommand("copy");
        selection.removeAllRanges();

        setAlertVisible(true);

        setTimeout(() => {
            setAlertVisible(false);
        }, 6000);
    };
    const handleDelete = (i) => {
        setTags(tags.filter((tag, index) => index !== i));
    };

    const handleDrag = (tag, currPos, newPos) => {
        const newTags = tags.slice();
        newTags.splice(currPos, 1);
        newTags.splice(newPos, 0, tag);
        setTags(newTags);
    };

    const addTagFromInput = () => {
        if (newEmail.trim() !== "") {
            const newTag = { id: tags.length + 1, text: newEmail.trim() };
            handleAddition(newTag);
            setNewEmail(""); // Clear input field after adding the tag
        }
    };

    function openModalForLink() {
        setIsOpenForLink(true);
    }

    function closeModalForLink() {
        setNewEmail("");
        setIsOpenForLink(false);
    }

    async function sendInvateStudent() {
        Swal.fire({
            title: "Are you sure?",
            text: "You are going to send a link to all of these course emails!",
            icon: "question",
            showCancelButton: true,
            confirmButtonColor: "#3085d6",
            cancelButtonColor: "#d33",
            confirmButtonText: "Yes, Send",
        }).then((result) => {
            if (result.isConfirmed) {
                sendInvate(studentsEmails);
            }
            setLoadingData(true);
        });
    }
    const getStudentsByCourseId = async () => {
        setLoadingData(false);
        let skipTake = {
            skip: skipData,
            take: showData,
        };
        const result = await Repository.postRequest(
            `api/students/findStudentsByCourseId/${course_id}`,
            skipTake
        );

        if (result.data.success == true) {
            setStudentsData(result.data.data);
        }
        setLoadingData(true);
    };

    function openModalForAddStudent() {
        setIsOpenForAddStudent(true);
    }

    function closeModalForAddStudent() {
        setTags([]);
        setValidEmail("");
        setNewEmail("");
        setIsOpenForAddStudent(false);
    }

    const sendInvate = async (val) => {
        setLoadingData(false);
        let newData = {
            email: val,
            course_id: course_id,
            course_name: courseName,
        };

        const response = await Repository.postRequest(
            `api/users/sendInvateEmail`,
            newData
        );
        if (response.data?.success === true) {
            closeModalForAddStudent();
            setLoadingData(true);
            getStudentsByCourseId();
            getStudentsEmailsByCourseId();
            Swal.fire({
                text: "Invite  has been sent to emails.",
                icon: "success",
                confirmButtonColor: "#16285e",
            });
        }
        setLoadingData(true);
    };

    const addStudents = async (val) => {
        let newData = {
            email: val,
            course_id: course_id,
        };
        const response = await Repository.postRequest(
            `api/students/createStudents`,
            newData
        );
        if (response.data?.success === true) {
            sendInvate(val);
        }
    };
    const getStudentsEmailsByCourseId = async () => {
        setLoadingStudents(false);

        const result = await Repository.findByEndPoint(
            `api/students/getStudentsByCourseId/${course_id}`
        );

        if (result.data.success == true) {
            setStudentsEmails(
                result.data.data.map((item) => {
                    return item.email;
                })
            );
        }
        setLoadingStudents(true);
    };
    useEffect(() => {
        getStudentsEmailsByCourseId();
    }, []);

    useEffect(() => {
        localStorage.setItem("course_id", course_id);
        getStudentsByCourseId();
    }, [skipData, showData]);

    useEffect(() => {
        setShowCources(isInvateValue);
    }, [isInvateValue]);

    return loadingData && loadingStudents ? (
        <div className="testBodyDiv homeSection">
            <div className="childSec mb-2 px-2">
                <div className="clidrenDivCompakt testH1">
                    <div className="mt-3 ">
                        <h1>{courseName} - Students</h1>
                    </div>
                </div>
                {role != "instructor" ? (
                    ""
                ) : (
                    <div className="notesHeadButtonsDiv">
                        <div
                            className="createBtnDiv createBtnDiv1 createBtnDivForStudent hoverStyle"
                            onClick={() => {
                                openModalForAddStudent();
                            }}
                            id="addStudents"
                        >
                            <span className="plus">+</span>
                            <span>Add students</span>
                        </div>
                        <div
                            className="createBtnDiv createBtnDiv1 createBtnDivForStudent hoverStyle"
                            onClick={() => {
                                openModalForLink();
                            }}
                            id="getLink"
                        >
                            <span className="plus">+</span>
                            <span>Get Link</span>
                        </div>
                        <div
                            className={`createBtnDivForStudent createBtnDiv1 ${
                                studentsEmails.length === 0
                                    ? "disabled"
                                    : "hoverStyle"
                            }`}
                            onClick={() => {
                                if (studentsEmails.length > 0) {
                                    sendInvateStudent();
                                }
                            }}
                            id="share"
                        >
                            <span className="plus prob ">+</span>
                            <span>SHARE WITH MY STUDENTS</span>
                        </div>
                    </div>
                )}
            </div>
            {studentsData.length > 0 ? (
                <div>
                    <StudentsTable
                        studentsData={studentsData}
                        course_id={course_id}
                        setLoadingData={setLoadingData}
                        loadingData={loadingData}
                        canDoIt={canDoIt}
                        courseName={courseName}
                    />

                    <PagePagination
                        setShow={setShowData}
                        count={6}
                        setSkip={setSkipData}
                        skip={skipData}
                        show={showData}
                    />
                </div>
            ) : (
                <div>
                    <h5 className="nodata">No data created yet.</h5>
                </div>
            )}

            <Modal
                isOpen={modalIsOpenForAddStudent}
                onRequestClose={closeModalForAddStudent}
                style={customStyles}
                ariaHideApp={false}
                contentLabel="Example Modal"
            >
                <div className="showNotes">
                    <h2>Share with my students</h2>
                    <img
                        src={x_mark}
                        onClick={closeModalForAddStudent}
                        className="closeModalImg"
                    />
                </div>
                <div>
                    <Formik
                        initialValues={{
                            email: "",
                        }}
                        validate={(values) => {
                            const errors = {};

                            return errors;
                        }}
                        onSubmit={({ setSubmitting }) => {
                            if (tags.length == 0) {
                                setValidEmail("Email is required.");
                            } else {
                                addStudents(
                                    tags.map((val) => {
                                        return val.text;
                                    })
                                );
                                setSubmitting(false);
                            }
                        }}
                    >
                        {({ isSubmitting }) => (
                            <Form className="formikEvents">
                                <Row>
                                    <Col xl="12" md="12" sm="12">
                                        <div className="custom-tags-container addEmailDiv">
                                            <div className="reactTagsDiv">
                                                <ReactTags
                                                    tags={tags}
                                                    inline={false}
                                                    // delimiters={delimiters}
                                                    handleDelete={handleDelete}
                                                    handleAddition={
                                                        handleAddition
                                                    }
                                                    handleDrag={handleDrag}
                                                    inputFieldPosition="bottom"
                                                    placeholder="Press enter to add new email"
                                                    autocomplete
                                                />
                                            </div>
                                            {/* <button className="addEmailBtn">Add</button> */}
                                            <div className="reactTagsJoinInput">
                                                <input
                                                    type="text"
                                                    value={newEmail}
                                                    onChange={(e) =>
                                                        setNewEmail(
                                                            e.target.value
                                                        )
                                                    }
                                                    placeholder="Enter email"
                                                    onKeyDown={(e) => {
                                                        if (e.key === "Enter") {
                                                            e.preventDefault();
                                                            // Call the function to add a tag or perform any other action
                                                            addTagFromInput();
                                                        }
                                                    }}
                                                />
                                                <button
                                                    className="addEmailBtn"
                                                    type="button"
                                                    onClick={addTagFromInput}
                                                >
                                                    Add
                                                </button>
                                            </div>
                                        </div>

                                        <div className="errorMessage mt-2">
                                            {validEmail && <p>{validEmail}</p>}
                                        </div>

                                        <ErrorMessage
                                            className="errorMessage mt-2"
                                            name="email"
                                            component="div"
                                        />
                                    </Col>
                                    <Col xl="12" md="12" sm="12">
                                        <div className="modalBtn btns">
                                            <button
                                                type="submit"
                                                className="btnOk"
                                                // disabled={isSubmitting}
                                            >
                                                Send
                                            </button>
                                            <button
                                                type="button"
                                                onClick={() => {
                                                    closeModalForAddStudent();
                                                }}
                                                className="btnCancel"
                                            >
                                                Cancel
                                            </button>
                                        </div>
                                    </Col>
                                </Row>
                            </Form>
                        )}
                    </Formik>
                </div>
            </Modal>
            <Modal
                isOpen={modalIsOpenForLink}
                onRequestClose={closeModalForLink}
                style={customStyles}
                ariaHideApp={false}
                contentLabel="Example Modal"
            >
                <div className="showNotes">
                    <h2>Link for invite</h2>
                    <img
                        src={x_mark}
                        onClick={closeModalForLink}
                        className="closeModalImg"
                    />
                </div>
                <div>
                    <Formik
                        initialValues={{
                            email: "",
                        }}
                        validate={(values) => {
                            const errors = {};

                            if (!values.email) {
                                errors.email = "Email is required.";
                            }

                            return errors;
                        }}
                        onSubmit={(values) => {
                            sendInvate(values);
                        }}
                    >
                        {({ isSubmitting }) => (
                            <Form className="formikEvents mb-4">
                                <Row>
                                    <Col xl="12" md="12" sm="12">
                                        <div className="paymentInfoContent copyLink">
                                            <div className="linkContent">
                                                <span
                                                    ref={copyLinkRef}
                                                    className="copyLink "
                                                >
                                                    {`${process.env.REACT_APP_FRONT_ENDPOINT}invite?course_id=${course_id}&course_name=${courseName}`}
                                                </span>
                                                <img
                                                    onClick={handleCopyLink}
                                                    src={copy}
                                                    alt="copy"
                                                    style={{
                                                        cursor: "pointer",
                                                    }}
                                                />
                                            </div>
                                            {alertVisible && (
                                                <div className="copyLinkItem">
                                                    Link copied!
                                                </div>
                                            )}
                                        </div>
                                        {/* <Field
                                            className="formikInput"
                                            type="email"
                                            name="email"
                                            placeholder="Email*"
                                        /> */}
                                    </Col>
                                </Row>
                            </Form>
                        )}
                    </Formik>
                </div>
            </Modal>
        </div>
    ) : (
        <Spinner spiner={true} />
    );
};

export default CourseStudents;
